import api from '@/api';
import { ReportTokenRequest, ReportTokenResponse } from './reportToken.types';
import { API_BASE_URL } from '..';

const CONTROLLER = `${API_BASE_URL}/report-token`;

export default {
  async generateToken(data: ReportTokenRequest) {
    const result = (await api.post(CONTROLLER, data)) as unknown;
    return result as ReportTokenResponse;
  },
};
